import type { ReactNode } from 'react'
import React from 'react'

import useBreakpoints from '../../../hooks/useBreakpoints'
import BurgerMenu from './BurgerMenu/BurgerMenu'
import type { MenuContentProps } from './MenuContent/MenuContent'
import MenuContent from './MenuContent/MenuContent'

export type MenuProps = Omit<MenuContentProps, 'onClose'> & { title?: string; children?: ReactNode }

const Menu = ({ title, ...props }: MenuProps) => {
  const { isMobile, isTablet } = useBreakpoints()

  return isMobile || isTablet ? <BurgerMenu title={title} {...props} /> : <MenuContent {...props} />
}

export default Menu
